<template lang="html">
  <div style="flex-grow: 1; display: flex;max-width:100%;">
    <div class="head-filter">
      <FilterBar
          :establishments="establishments"
          :establishment="establishment"
          :sentiments="sentiments"
          :sentiment="sentiment"
          :platforms="platforms"
          :platform="platform"
          :status_set="status_set"
          :status="status"
          :tag_set="tag_set"
          :tag="tag"
          :dateBegin="dateBegin"
          :dateEnd="dateEnd"
          :consultants="consultants"
          :consultant="consultant"
          :classified="classified"
          :pourcentageStatTagValue="pourcentageStatTagValue"
          :padAndLogos="false"
          :showConsultant="true"
          @update:establishment="establishmentClicked"
          @update:sentiment="sentimentClicked"
          @update:platform="platformClicked"
          @update:status="stateClicked"
          @update:tag="tagClicked"
          @update:dateBegin="dateBeginClicked"
          @update:dateEnd="dateEndClicked"
          @update:consultant="consultantClicked"
          @update:classified="classifiedClicked"
          @previousEstablishment="previousEstablishment"
          @nextEstablishment="nextEstablishment"
      />
    </div>
    <StatsTeam v-if="$store.state.stats"/>
    <ReviewListPaginated :filters="filters" :autoload="true" title="" @update-search-string="updateSearchString"/>
  </div>
</template>
<script>
import ReviewListPaginated from '@/components/ReviewListPaginated';
import DropDown from '@/components/DropDown';
import DropDownSearch from '@/components/ui/DropDownSearch.vue';
import PourcentageStatTag from '@/components/PourcentageStatTag.vue';
import StatsTeam from '@/components/StatsTeam.vue';
import gql from '@/gqlService.coffee';
import utils from '@/utils.js';
import queries from '@/gql/queries.coffee';
import 'bulma-switch';
import DatePicker from 'vue2-datepicker'
import settings from '@/settings.coffee';
import DateInput from "@/components/ui/DateInput.vue";
import UiSwitch from "@/components/ui/Switch.vue";
import FilterBar from "@/components/filter/FilterBar.vue";

export default {
  name: 'ReviewListFilterTeam',
  components: {
    FilterBar,
    UiSwitch,
    DateInput,
    ReviewListPaginated,
    DropDown,
    DropDownSearch,
    StatsTeam,
    PourcentageStatTag,
    DatePicker
  },
  props: {},
  data() {
    return {
      dateBegin: null,
      dateEnd: null,
      has_game_filter: false,
      status_set: null,
      tag: {name: null},
      tag_set: [
        {name: 'Supprimé', code: 'deleted'},
        {name: 'Répondu', code: 'answered'},
        {name: 'Impossible', code: 'Impossible'}
      ],
      status: {name: null, uid: null},
      sentiments: [
        {name: 'Positif', value: true},
        {name: 'Négatif', value: false}
      ],
      sentiment: {name: null, value: null},
      classified: false,
      height: (window.innerHeight - 30) + 'px',
      listHeight: (window.innerHeight - 260) + 'px',
      late: false,
      search_string: '',
      platform: {name: null},
      platforms: [],
      establishment: {name: null},
      establishments: [],
      consultant: {lastname: null},
      consultants: [],
    };
  },
  computed: {
    is_production() {
      return settings.backendUrl === 'https://hermes.mhr.re';
    },
    style() {
      return {
        height: this.height
      };
    },
    pourcentageStatTagValue() {
      let ret = 0;
      if (this.$store.state.stats) {
        const sum = this.$store.state.stats.reduce((acc, current) => {
          acc.total += current['from_this_morning_count'];
          acc.total -= current['from_this_morning_impossible'];
          acc.validated += current['from_this_morning_validated_count'];
          return acc;
        }, {total: 0, validated: 0});

        if (sum.total !== 0) {
          ret = Math.round(100 * sum.validated / sum.total);
        }
      }
      return ret;
    },
    filters() {
      return {
        status: this.status,
        sentiment: this.sentiment,
        classified: this.classified,
        late: this.late,
        platform: this.platform,
        establishment: this.establishment,
        consultant: this.consultant,
        search_string: this.search_string,
        dateBeginFilter: utils.formatDate(this.dateBegin, 'YYYY-MM-DD'),
        dateEndFilter: utils.formatDate(this.dateEnd),
        tag: this.tag,
        has_game_filter: this.has_game_filter
      };
    }
  },
  methods: {
    tagClicked(item) {
      this.tag = item || {name: null};
    },
    dateBeginClicked(item) {
      this.dateBegin = item || null;
    },
    dateEndClicked(item) {
      this.dateEnd = item || null;
    },
    sentimentClicked(item) {
      this.sentiment = item || {name: null, value: null};
    },
    platformClicked(item) {
      this.platform = item || {name: null};
    },
    establishmentClicked(item) {
      this.establishment = item || {name: null};
    },
    consultantClicked(item) {
      this.consultant = item || {lastname: null};
    },
    stateClicked(item) {
      this.status = item || {name: null, value: null};
      this.classified = (this.status.value === 'Classified');
    },
    classifiedClicked(item) {
      this.classified = item;
      if (this.classified) {
        this.status = {name: 'Classé', value: 'Classified'};
      } else {
        this.status = {name: null, value: null};
      }
    },
    setHeight: utils.debounce(function () {
      this.height = (window.innerHeight - 30) + 'px';
      this.listHeight = (window.innerHeight - 260) + 'px';
    }, 500),
    updateSearchString(newSearchString) {
      this.search_string = newSearchString;
    },
    previousEstablishment() {
      if (!Array.isArray(this.establishments) || this.establishments.length === 0) return;

      const currentIndex = this.establishments.indexOf(this.establishment);

      if (currentIndex > 0) {
        this.establishment = this.establishments[currentIndex - 1];
      } else {
        this.establishment = this.establishments[this.establishments.length - 1];
      }
    },

    nextEstablishment() {
      if (!Array.isArray(this.establishments) || this.establishments.length === 0) return;

      const currentIndex = this.establishments.indexOf(this.establishment);

      if (currentIndex >= 0 && currentIndex < this.establishments.length - 1) {
        this.establishment = this.establishments[currentIndex + 1];
      } else {
        this.establishment = this.establishments[0];
      }
    }

  },
  async mounted() {
    this.setHeight();
    window.addEventListener('resize', this.setHeight);

    const data = await queries.run('named_state_set');
    this.status_set = data.body.data.named_state_set;

    this.establishments = await gql.query({
      model: 'establishment_set',
      fields: 'uid name',
      filters: 'active: true'
    });
    this.consultants = await gql.query({
      model: 'consultant_set',
      fields: 'uid lastname firstname fullname'
    })
    this.platforms = await gql.query({
      model: 'platform_set',
      fields: 'uid name'
    }),
        this.$djangows['onmodelsignals']({modelName: 'review', appLabel: 'review'}, async (event) => {
          const response = await queries.run('get_consultants_stats_from_view', []);
          this.$store.commit('set_stats', response.body.data.get_consultants_stats_from_view);
        });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setHeight);
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.drop {
  width: 33%;
}

.card-content {
  padding: 10px;
}

.card-header-title {
  padding: 0 0 10px 0;
}

.drop {
  width: 33%;
}

.pad {
  padding-top: 4em;
}

.head-filter {
  background-color: #fff;
  display: block;
  position: absolute;
  top: 0;
  padding-top: 1.5em !important;
  padding-left: 0.5em;
  padding-bottom: 0.7em !important;
  width: 100%;
  min-width: 1500px;
}

.clear-date {
  font-size: 12px;
  color: black;
  position: absolute;
  right: 20px;
  top: 8px;
  cursor: pointer;
}

.top-label {
  padding-top: 0px;
  padding-left: 5px;
  margin-left: 5px !important;
  width: 135px !important;
}

.top-label > input {
  width: 120px !important;
}
</style>
